/* ============================================
   byte-other-colors.js – Other colors swatches (PLP/PDP)
   On product card: swatch click switches card images to that product's gallery.
   ============================================ */

function parseGalleryUrls(str) {
  if (!str || typeof str !== 'string') return []
  try {
    const decoded = str.replace(/&quot;/g, '"').replace(/&#39;/g, "'")
    const parsed = JSON.parse(decoded)
    return Array.isArray(parsed) ? parsed.filter((u) => u && String(u).trim()) : []
  } catch {
    return []
  }
}

function syncCardContent(card, swatch, productUrl) {
  if (!card || !swatch) return

  const titleText = swatch.dataset.productTitle
  const priceHtml = swatch.dataset.productPriceHtml
  const saleVisible = swatch.dataset.productSaleVisible === 'true'

  const titleEl = card.querySelector('.custom-title-clamp .element-text')
  if (titleEl && titleText) {
    titleEl.textContent = titleText
  }

  const overlayLink = card.querySelector('.grid-item__overlay-link')
  if (overlayLink && productUrl) {
    overlayLink.setAttribute('href', productUrl)
    if (titleText) {
      overlayLink.setAttribute('aria-label', titleText)
    }
  }

  const priceWrapper = card.querySelector('[data-product-card-price]')
  if (priceWrapper && priceHtml) {
    priceWrapper.innerHTML = priceHtml
  }

  const saleBadge = card.querySelector('[data-product-card-sale-badge]')
  if (saleBadge) {
    saleBadge.hidden = !saleVisible
  }
}

if (!customElements.get('byte-other-colors')) {
  class ByteOtherColors extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.addEventListener('click', this.#handleClick.bind(this))
      const card = this.closest('.product-grid-item')
      const currentSwatch = this.querySelector('.byte-other-colors__swatch[data-current-product="true"]')
      if (card && currentSwatch) {
        currentSwatch.classList.add('is-active')
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#handleClick.bind(this))
    }

    #handleClick(e) {
      const swatch = e.target.closest('.byte-other-colors__swatch[data-product-gallery-urls]')
      if (!swatch) return

      const urlsRaw = swatch.dataset.productGalleryUrls
      const productUrl = swatch.dataset.productUrl
      const productHandle = swatch.dataset.productHandle
      const productId = swatch.dataset.productId
      const urls = parseGalleryUrls(urlsRaw)
      if (urls.length === 0) return

      const card = this.closest('.product-grid-item')
      if (!card) return

      if (productHandle) card.setAttribute('data-product-handle', productHandle)
      if (productId) card.setAttribute('data-product-id', productId)

      const galleryWrap = card.querySelector('[data-product-card-gallery]')
      if (galleryWrap && typeof galleryWrap._productCardGallerySetImages === 'function') {
        e.preventDefault()
        e.stopPropagation()
        galleryWrap._productCardGallerySetImages(urls)
        if (typeof galleryWrap._productCardGallerySetOverlayHref === 'function' && productUrl) {
          galleryWrap._productCardGallerySetOverlayHref(productUrl)
        }
      }

      syncCardContent(card, swatch, productUrl)

      this.querySelectorAll('.byte-other-colors__swatch.is-active').forEach((el) => el.classList.remove('is-active'))
      swatch.classList.add('is-active')
    }
  }

  customElements.define('byte-other-colors', ByteOtherColors)
}
